var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarCleanInside(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#DBF5FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1658 21.0535C34.7222 20.4646 33.0743 20.0591 32.3771 18.9994C31.6799 17.9397 31.1092 15.6448 29.3348 14.7631C27.5603 13.8813 24.1688 13.6338 22.2322 13.6338C20.2956 13.6338 16.9065 13.8759 15.1297 14.7613C13.3528 15.6467 12.7845 17.9397 12.0874 18.9976C11.3902 20.0555 9.74222 20.4646 9.29862 21.0535C8.85501 21.6423 8.54273 25.3649 8.73276 27.1901C8.92279 29.0154 9.27744 30.0951 9.27744 30.0951H14.4821C15.3342 30.0951 15.6114 29.7749 17.3544 29.6109C19.2668 29.4293 21.1429 29.3688 22.2322 29.3688C23.3216 29.3688 25.2582 29.4293 27.1694 29.6109C28.9123 29.7761 29.1986 30.0951 30.0416 30.0951H35.1858C35.1858 30.0951 35.5404 29.0154 35.7305 27.1901C35.9205 25.3649 35.607 21.6423 35.1658 21.0535Z",
    stroke: "#0FBCF9",
    strokeWidth: 1.93662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.947 30.0951H34.3361V31.0634H30.947V30.0951Z",
    stroke: "#0FBCF9",
    strokeWidth: 1.93662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1284 30.0951H13.5175V31.0634H10.1284V30.0951Z",
    stroke: "#0FBCF9",
    strokeWidth: 1.93662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7968 25.5658C28.4391 25.1525 27.2735 24.8075 25.7303 24.5763C24.187 24.3451 23.6242 24.2852 22.2443 24.2852C20.8645 24.2852 20.2369 24.3845 18.7578 24.5763C17.2787 24.7682 16.1682 25.1095 15.6919 25.5658C14.9772 26.2581 16.0242 27.0352 16.846 27.1296C17.6424 27.2204 19.2347 27.1871 22.251 27.1871C25.2673 27.1871 26.8595 27.2204 27.656 27.1296C28.4766 27.0298 29.4486 26.3066 28.7968 25.5658Z",
    fill: "#0FBCF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8576 21.5649C32.8542 21.5168 32.8332 21.4717 32.7986 21.4382C32.7639 21.4047 32.7182 21.3851 32.67 21.3833C31.9553 21.3579 31.2296 21.4087 29.9424 21.7882C29.2857 21.9799 28.669 22.2887 28.122 22.6996C27.984 22.8073 28.033 23.0984 28.2061 23.1293C29.2671 23.2537 30.3344 23.3164 31.4027 23.3169C32.0436 23.3169 32.7051 23.1353 32.828 22.564C32.8906 22.2346 32.9006 21.8974 32.8576 21.5649Z",
    fill: "#0FBCF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6069 21.5649C11.6103 21.5168 11.6313 21.4717 11.6659 21.4382C11.7005 21.4047 11.7463 21.3851 11.7945 21.3833C12.5092 21.3579 13.2348 21.4087 14.5221 21.7882C15.1788 21.9799 15.7955 22.2887 16.3425 22.6996C16.4805 22.8073 16.4315 23.0984 16.2584 23.1293C15.1974 23.2537 14.13 23.3164 13.0618 23.3169C12.4209 23.3169 11.7594 23.1353 11.6365 22.564C11.5739 22.2346 11.5639 21.8974 11.6069 21.5649Z",
    fill: "#0FBCF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8837 18.4753H33.852",
    stroke: "#0FBCF9",
    strokeWidth: 1.93662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6125 18.4753H11.5809",
    stroke: "#0FBCF9",
    strokeWidth: 1.93662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4598 19.6252C11.4598 19.6252 14.2649 18.899 22.2323 18.899C30.1997 18.899 33.0047 19.6252 33.0047 19.6252",
    stroke: "#0FBCF9",
    strokeWidth: 1.93662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarCleanInside);
export default __webpack_public_path__ + "static/media/car-clean-inside.7fd361f9bb00ae88acd27b8258a9786d.svg";
export { ForwardRef as ReactComponent };